<template lang="pug">
.box(:disabled="isLoading")
    .box-header.header.b-b
        h3(v-if="mode === 'pages'") Pages {{ activeGroupId }}
        h3(v-if="mode === 'page-form'") {{ pageExists ? 'Update' : 'Add' }} Page

    .box-divider.m-a-0(v-show="mode === 'page-form'")

    .box-tool(v-if="canManageOrderLayout")
        a.nav-link.text-muted(v-if="mode === 'pages'" @click="addNewPage()")
            i.material-icons.md-18 add

        a.nav-link.text-muted(v-if="mode !== 'pages'" @click="selectMode('pages')")
            i.material-icons.md-18 close

    vue-draggable.list.box(
        v-model="pageList"
        v-show="mode === 'pages'"
        :options="{ disabled: isLoading, handle: '.drag-handler'}"
    )
        .list-item.page-list(
            v-for="(page, index) in pageList",
            :key="`page_${page.id}`",
            :class="{ dker: activePage.id == page.id }"
        )
            .list-body
                div
                    i.material-icons.md-18.drag-handler.text-muted.m-r-1(v-if="canManageOrderLayout") reorder
                    span.page-name._500.pointer(@click="setPage(page)") {{ page.name }}

                div
                    span
                        i.text-muted(v-if="!page.cells.length") No cells assigned
                        i(v-else) {{ page.cells.length }} cells assigned

                    .inline.m-l-1(v-if="canManageOrderLayout")
                        button.btn.white.dropdown-toggle.p-a-xs.btn-xs(
                            data-toggle="dropdown",
                            aria-expanded="true"
                        )
                        .dropdown-menu.dropdown-menu-right
                            a.dropdown-item(@click="editPage(page)") Edit
                            a.dropdown-item(v-if="groupPages.length > 1", @click="deletePage(page.id)") Delete

    .box-body(v-if="mode === 'page-form'")
        .form-group.m-b-0
            label.form-control-label Name
            input.form-control(
                type="text",
                v-focus="",
                key="page-name",
                v-model="page.name"
            )

    .box-footer.b-t(v-if="mode !== 'pages'")
        .set-buttons
            button.btn.btn-sm.white(@click="selectMode('pages')")
                span Cancel

            button.btn.btn-sm.primary(
                :disabled="page.name == null || page.name.trim() == ''"
                @click="submit()"
            )
                span Save
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import LoadingMixin from '../mixins/loading';
import PermissionMixin from '../order-layout-permission';

export default {
    mixins: [PermissionMixin, LoadingMixin],

    data() {
        return {
            mode: 'pages',
            page: {
                id: null,
                name: null,
                cells: [],
            },
        };
    },

    computed: {
        ...mapGetters('orderLayout', [
            'activeGroupId',
            'activeGroupPages',
            'activePage',
            'getGroupPages',
        ]),

        groupPages() {
            return this.getGroupPages(this.activeGroupId);
        },

        pageExists() {
            return this.page.id !== null;
        },

        pageList: {
            get() {
                return this.activeGroupPages;
            },

            set(pages) {
                pages.forEach((p, index) => {
                    this.setPageAttribute({
                        page_id: p.id,
                        key: 'sequence',
                        value: index + 1,
                    });
                });
            },
        },
    },

    methods: {
        ...mapActions('orderLayout', [
            'addPage',
            'removePage',
            'setPageAttribute',
            'updatePage',
            'viewPage',
        ]),

        addNewPage() {
            this.page.id = null;
            this.page.name = null;
            this.cells = [];

            this.selectMode('page-form');
        },

        async deletePage(page_id) {
            const { value } = await swal({
                title: 'Are you sure?',
                text: 'Delete page will delete all cells in the page',
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#d33',
                cancelButtonColor: '#fff',
                cancelButtonClass: 'text-dark',
                confirmButtonText: 'Yes, delete it!',
            });

            if (value) {
                this.removePage(page_id);
                this.viewPage(_.first(this.activeGroupPages));
            }
        },

        editPage(page) {
            this.page = _.clone(page);
            this.selectMode('page-form');
        },

        selectMode(mode) {
            if (this.isLoading) return;
            this.mode = mode;
        },

        setPage(page) {
            if (this.activePage.id == page.id) return;
            this.viewPage(page);
        },

        submit() {
            if (this.page.id === null) {
                const page = Object.assign(
                    { group_id: this.activeGroupId },
                    this.page,
                );

                this.addPage(page);
            } else {
                this.updatePage({
                    page_id: this.page.id,
                    key: 'name',
                    value: this.page.name,
                });
            }

            this.selectMode('pages');
        },
    },
};
</script>

<style lang="scss" scoped>
@import '../../../../sass/pages/rounded_input';

.drag-handler {
    cursor: move;
}

.page-list {
    .list-body {
        span.page-name {
            text-decoration: underline;
        }
    }
}

.dropdown {
    display: inline-block;
}

.form-control-label {
    margin-bottom: 0.5rem;
    padding: 0;
}

.list-body,
.header,
.set-buttons {
    align-items: center;
    display: flex;
    justify-content: space-between;
}

label {
    font-weight: 500;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/order-layout/action/action-pages.vue